import * as coreAxios from "axios";
import { getCookie, signout } from "./cookies";
import { baseUrl } from "./constants";
import { setSnackBar } from "../store/common/commonSlice";

export const axios = coreAxios.default.create({
  baseURL: baseUrl,
  headers: {
    common: {
      Authorization: `BEARER ${getCookie("token")}`,
    },
  },
});

const axiosInterceptor = (dispatch) => {
  axios.interceptors.request.use(
    function (config) {
  
      const token = getCookie("token");
      if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `BEARER ${token}`;
      }
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      const { method } = response.config;
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      if (method !== "get") {
        let message = response?.data?.detail || "success";
        let showSnackBar = true;

        if (response.config.url && response.config.url.includes('/job/update/')) {
          message = "Job update success";
        }
        else if (response.config.url && response.config.url.includes('/submit') && (response.config.url.includes('/job/') || response.config.url.includes('process'))) {
          message = "Job create success";
        }
        // User
        else if (response.config.url && (response.config.url.includes('/user'))) {
          if (method === 'post' && response.config.url.includes('/company/') && response.config.url.endsWith('/user')) {
            message = "User created successfully";
          } else if (method === 'put' && response.config.url.includes('/company/user/')) {
            message = "User updated successfully";
          }
        }
        // Assign to Process
        else if (response.config.url && response.config.url.includes('/assign-stage')) {
          showSnackBar = false;
        } else if (response.config.url && response.config.url.includes('/assign_to_stage')) {
          if (method === 'post') message = "Assign to Stage created successfully";
          else if (method === 'put') message = "Assign to Stage updated successfully";
        }
        // Process 
        else if (response.config.url && response.config.url.includes('/process') && !response.config.url.includes('company')) {
          if (method === 'post' && response.config.url.endsWith('/process')) message = "Process created successfully";
          else if (method === 'put') message = "Process updated successfully";
        }
        // Stage
        else if (response.config.url && response.config.url.includes('/stage')) {
          if (method === 'post') message = "Stage created successfully";
          else if (method === 'put') message = "Stage updated successfully";
        }
        // Email Config
        else if (response.config.url && response.config.url.includes('/email-config')) {
          if (method === 'post') message = "Email Configuration created successfully";
          else if (method === 'put') message = "Email Configuration updated successfully";
        }
        // Email Notification
        else if (response.config.url && response.config.url.includes('/email-notification')) {
          if (method === 'post') message = "Email Notification created successfully";
          else if (method === 'put') message = "Email Notification updated successfully";
        }
        // Company
        else if (response.config.url && response.config.url.includes('/company')) {
          if (method === 'post' && response.config.url.endsWith('/company')) {
            message = "Company created successfully";
            message = "Company updated successfully";
          }
        }

        if (showSnackBar) {
          dispatch(
            setSnackBar({
              open: true,
              message: message,
              severity: "success",
            })
          );
        }
      }
      return response.data;
    },
    function (error) {
      let message = error.message;
      if (error?.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          message = error.response.data.detail[0].msg || JSON.stringify(error.response.data.detail);
        } else if (typeof error.response.data.detail === 'string') {
          message = error.response.data.detail;
        } else {
          message = JSON.stringify(error.response.data.detail);
        }
      }
      
      if (error.response?.status !== 500) {
        dispatch(
          setSnackBar({
            open: true,
            message: message,
            severity: "error",
          })
        );
      }
      if (error.response?.status === 403) {
        window.location.replace('/page-403');
      }
      if (error.response?.status === 401) {
        const refreshToken = async () => {
          try {
            signout(() => window.location.reload());
          } catch (error) {
            dispatch(
              setSnackBar({
                open: true,
                message: "Failed to Logout the user.",
                severity: "error",
              })
            );
          }
        };
        refreshToken();
      }

      return Promise.reject(error);
      // return false;
    }
  );
};

export default axiosInterceptor;
